// Noshies theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu
  var nav = document.getElementById('SiteNav');
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.menu-toggle');
    if (!toggle || !nav) return;
    var open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Subscribe & Save toggle on product page
  var toggles = document.querySelectorAll('[data-purchase-toggle]');
  var planSelect = document.getElementById('SellingPlan');
  if (toggles.length && planSelect) {
    var syncPlanState = function () {
      var subscribe = document.querySelector('[data-purchase-toggle][value="subscribe"]');
      var isSub = subscribe && subscribe.checked;
      planSelect.disabled = !isSub;
      // Keep a valid option selected. planSelect has no blank "" option, so
      // setting .value = '' used to leave nothing selected (selectedIndex -1)
      // once a shopper switched back to Subscribe & Save.
      if (planSelect.selectedIndex === -1 && planSelect.options.length) {
        planSelect.selectedIndex = 0;
      }
    };
    toggles.forEach(function (radio) {
      radio.addEventListener('change', syncPlanState);
    });
    // Initialize from whichever radio is actually checked, instead of
    // assuming one-time purchase is always the default.
    syncPlanState();
    var priceEl = document.getElementById('SellingPlanPrice'); if (priceEl) { var updatePlanPrice = function () { var opt = planSelect.options[planSelect.selectedIndex]; if (opt && opt.getAttribute('data-price')) { priceEl.textContent = opt.getAttribute('data-price'); } }; planSelect.addEventListener('change', updatePlanPrice); updatePlanPrice(); }
  }
});
// ====================== WOW upgrades ======================
document.addEventListener('DOMContentLoaded', function () {
  // scroll reveals
  var revealEls = document.querySelectorAll('.story, .products-section, .why, .usvthem, .reviews, .rev, .card, .founders');
  revealEls.forEach(function (el) { el.classList.add('reveal'); });
  document.querySelectorAll('.story-grid figure, .why-item').forEach(function (el, i) {
    el.classList.add('reveal'); el.style.setProperty('--stagger', i % 4);
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal, .uvt-row').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in-view'); });
  }

  // parallax + header shrink + sticky CTA
  var scape = document.querySelector('.hero .scape');
  var header = document.querySelector('.site-header');
  var cta = document.getElementById('StickyCta');
  var hero = document.querySelector('.hero');
  var threshold = hero ? hero.offsetHeight * 0.9 : 600;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (scape && hero && y < hero.offsetHeight) scape.style.transform = 'translateY(' + (y * 0.12) + 'px)';
    if (header) header.classList.toggle('compact', y > 80);
    if (cta) cta.classList.toggle('show', y > threshold);
  }, { passive: true });

  // crumb burst on add-to-cart
  // Delegated on document (rather than bound only to the buttons found at
  // load) so it keeps working for add-to-cart buttons rendered or replaced
  // later, e.g. by an app's quick-add card or a cart-drawer re-render.
  var colors = ['#74391c', '#d9a468', '#f15d3e', '#77c5d5'];
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('button[name="add"], .btn-add');
    if (!btn) return;
    for (var i = 0; i < 18; i++) {
      var c = document.createElement('span');
      c.className = 'crumb';
      c.style.background = colors[i % colors.length];
      c.style.left = ev.clientX + 'px'; c.style.top = ev.clientY + 'px';
      document.body.appendChild(c);
      var ang = Math.random() * 2 * Math.PI, dist = 50 + Math.random() * 90;
      c.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist + 70) + 'px) scale(.4)', opacity: 0 }
      ], { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.17,.67,.4,1)' }).onfinish = function () { this.effect.target.remove(); };
    }
  });
});
// Product page thumbnail switching
// Delegated on document so thumbnails still work if the gallery is
// re-rendered later (e.g. after a variant change).
document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('PdpMainImage');
  if (!main) return;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-thumb');
    if (!btn) return;
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var img = btn.querySelector('img');
    main.src = btn.getAttribute('data-full');
    if (img) main.alt = img.alt;
    thumbs.forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });
});
